export default __webpack_public_path__ + "static/media/login-signup-image.a6f97d2c.png";